import Link from '@/components/base/TransitionLink';

interface Props {
  to: string;
  children: string;
  variant?: 'solid' | 'light' | 'line';
}

export default function ButtonLink({ to, children, variant = 'solid' }: Props) {
  const styles = {
    solid: 'bg-primary-500 text-background-50 hover:bg-accent-500',
    light: 'bg-background-50 text-foreground-950 hover:bg-accent-500 hover:text-background-50',
    line: 'border border-foreground-950 text-foreground-950 hover:bg-foreground-950 hover:text-background-50',
  }[variant];
  return (
    <Link
      to={to}
      className={`group inline-flex items-center gap-3 px-6 py-3.5 rounded-[2px] text-[12px] font-semibold uppercase tracking-[0.18em] whitespace-nowrap cursor-pointer transition-colors ${styles}`}
    >
      {children}
      <i className="ri-arrow-right-line transition-transform duration-300 ease-out group-hover:translate-x-1 motion-reduce:transition-none" />
    </Link>
  );
}